// Quell functions
window.quell = window.quell || {};
$quellTimeout: null,
$html = $('html');
$body = $(document.body);
$addtocartformSelector = 'form[action^="/cart/add"]';
$addtocartform = $($addtocartformSelector);
$cartToggle = '#cartToggle';
$cartCountSelector = '#cartCount>span';
$cartCountElement = $($cartCountSelector);
$cartdrawerSelector = '#cart-drawer';
$cartdrawer = $($cartdrawerSelector);
$cartWrap = $($cartdrawerSelector).find('.drawer-wrap');
$cartItems = $($cartdrawerSelector).find('.drawer-items');
$drawerOverlay = '#drawerOverlay';
$drawerClose = '#drawerOverlay, #drawerClose, #keepShopping';

$quickviewTemp = $('#QuickviewTemplate');
$quickview = $('#quickview');
$quickviewClose = $quickview.find('.close-window');
$quickviewOverlay = $quickview.find('.overlay');

$moneyFormat = "$ USD";
$productaddcart = '#product-add-to-cart',
$checkoutButtonSelectors = "[name='checkout'], [href='/checkout'], form[action='/checkout'] input[type='submit'], .checkout_button";

quell.init = function() {
  
  	quell.initQuickView();
  
  quell.toggleCartDrawer();
  quell.general();
  quell.searchHandler();
  quell.CartRecurringChoice();
  setTimeout(function(){
  //  quell.bindEvents();
  }, 3000);
};

quell.general = function() {
  $body.on('click',$checkoutButtonSelectors, function(e) {
    if (window.CartHasSubscriptionItem) {
  	e.preventDefault();
    quell.saveCartNoteThenRedirect();
    }
  });
  // Add or remove from the quantity
  $body.on('click', '.js-btn-qty', function() {
    var $el = $(this),
        line = $el.data('line'),
        qty = $el.siblings('.qty-num[data-line="' + line + '"]').val();
        var qty = quellCart.validateQty(qty);
        if ($el.hasClass('qty-plus')) {
          qty = parseInt(qty) + 1;
        } else if (qty > 1) {
          qty = parseInt(qty) - 1;
        }
        $el.siblings('.qty-num[data-line="' + line + '"]').val(qty).change();
  });

  $('.image-slider').slick({
      dots: true,
      lazyLoad: 'ondemand',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      adaptiveHeight: false
    });
};
quell.CartRecurringChoice = function() {
  $body.on('change', '.recurring_choice input[type="radio"]', function() {
    $("input[name=id]").val($(this).data('id'));
      if($(this).val() == 'autodeliver'){
        $(".subscription_id").attr('name','properties[subscription_id]');
        $(".shipping_interval_frequency").attr('name','properties[shipping_interval_frequency]');
        $(".shipping_interval_unit_type").attr('name','properties[shipping_interval_unit_type]');
      } else if ($(this).val() == 'onetime') {
        $(".subscription_id").attr('name','');
        $(".shipping_interval_frequency").attr('name','');
        $(".shipping_interval_unit_type").attr('name','');
      }
  });
};
quell.searchHandler = function() {
  var hideSearch = function(e) {
  	 element = $(e.target);
  	 if(!element.is('.nav-search') && element.parents('.nav-search').length == 0) {
  		$('.nav-search').removeClass('active');
  	 }
   };
  $body.on('mousedown', $.proxy( hideSearch, this) );

  $('.nav-search .search-submit').on('click', function(e) {
  	if (!$('.nav-search').hasClass('active')) {
      e.preventDefault();
  		$('.nav-search').addClass('active');
      return false;
  	}
  });
  $body.on('submit', '.nav-search:not(.active) form.search-form', function(e) {
      e.preventDefault();
  });
};
quell.toggleCartDrawer = function() {
//   $body.on('click', $cartToggle, function() {
//     $body.toggleClass('drawer-exposed')
//   });
  $body.on('click', $drawerClose, function() {
  	if($($productaddcart).length) {
  		$($productaddcart).val('Buy Now');
  	}
    $body.removeClass('drawer-exposed')
  })
  $body.on('afterCartLoad.ajaxCart', function(evt, cart) {
        console.log('added class');
        console.log('added class',  $(`${$cartdrawerSelector} input` ));
    $('#drawerClose').focus();
    $body.addClass('drawer-exposed');

});
};

quell.initQuickView = function() {
  $(".quickview-button").click(function() {
    var i = $(this).attr("id");
    return Shopify.getProduct(i, quell.quickViewCallback);
  });
  $body.on("click", ".overlay, .close-window", function() {
				quell.closeQuickView();
  });
};
quell.closeQuickView = function() {
  $quickview.fadeOut(500)
};
quell.quickViewCallback = function(i) {
  // console.log(i);
  jQuery.get(i.url + '?view=metafields.json', function (metafields, textStatus) {
    var metafields = jQuery.parseJSON( metafields );
  // console.log(i);
  // Handlebars.js cart layout
  var imgs = [],
      data = {},
      source = $('#QuickviewTemplate').html(),
      template = Handlebars.compile(source);
  var des = i.description.replace(/(<([^>]+)>)/gi, "");
  if (des.toLowerCase().indexOf("[description]") >= 0 && des.toLowerCase().indexOf("[/description]") >= 0) {
    des = des.substring(des.lastIndexOf("[description]")+13,des.lastIndexOf("[/description]"));
  } else {
    des = des.replace(/\[description\](.*)\[\/description\]/g, "");
    des = des.split(" ").splice(0, 20).join(" ") + "...";
  }
  $.each(i.images, function(index, image) {
    img = {
      img:  Shopify.resizeImage(image, "370x370")
    };
    imgs.push(img);
  });

  // Gather all cart data and add to DOM
  data = {
    id: i.variants[0].id,
    title: i.title,
    images: imgs,
    description: des,
    url: i.url,
    price: Shopify.formatMoney(i.price, window.money_format),
    has_subscription: metafields.has_subscription,
    subscription_only: metafields.subscription_only,
    subscription_id: metafields.subscription_id,
    discount_product_id: metafields.discount_product_id,
    discount_percentage: metafields.discount_percentage,
    widget_onetime_message: metafields.widget_onetime_message,
    widget_subscribe_message: metafields.widget_subscribe_message,
    widget_see_details: metafields.widget_see_details,
    widget_deliver_every: metafields.widget_deliver_every,
    single_purchase_id: metafields.single_purchase_id,
    single_purchase_price: metafields.single_purchase_price,
    recurring_purchase_id: metafields.recurring_purchase_id,
    recurring_purchase_price: metafields.recurring_purchase_price,
    shipping_interval_unit_type: metafields.shipping_interval_unit_type,
    shipping_interval_frequency: metafields.shipping_interval_frequency
  }
  $quickview.html(template(data)).fadeIn(500);
  $quellTimeout = setTimeout(function() {
    $('.quickview-image-slider',$quickview).slick({
      lazyLoad: 'ondemand',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      adaptiveHeight: false
    });
  }, 1000);
    });
};

quell.bindEvents = function() {
  var self = this;
//  this.mainNav = $("section.full_width#nav_full_width");
//  this.smallNav = $("nav#small_nav");
  this.mainHeader = $body.find("#header");
  this.mainNav = $body.find("#nav_full_width");
  this.smallNav = $body.find("#small_nav");
  this.mainHeaderOriginalTop = this.mainHeader.offset().top;
  this.mainNavOriginalTop = this.mainNav.offset().top;
  this.smallNavOriginalTop = this.smallNav.offset().top;
  var makeSticky;

  $body.on('click',".hover-menu",function(e){
    if (e.target.tagName.toLowerCase() !== 'input') {
      var sub = $(this).find(".submenu");
      sub.toggle();

      var menu_img = $(this).find("img");
      if (menu_img) { //only do this swap if we are using an img tag cause the svg didn't work out
        var hilite = menu_img.data("active-highlight");
        if (hilite) {
          var current_src = menu_img.attr("src");
          menu_img.attr("src", hilite);
          menu_img.data("active-highlight", current_src);
          menu_img.css("z-index", sub.css("display") !== "none" ? 4 : 0);
        }
      }

      var menu_svg = $(this).find("svg");
      if (menu_svg && !menu_svg.hasClass('menu_not_active')) {
        menu_svg.toggleClass('active_highlight');
      }
    }
  });

  $("#main_nav_items li").each(function(){
    var subnav = $(this).find("ul.subnav");
    if (subnav && subnav.length > 0) {
      $(this).hover(function(e){
        subnav.addClass('active');
        $(this).addClass('supernav_active');
      }, function(e){
        subnav.removeClass('active');
        $(this).removeClass('supernav_active');
      });
    }
  });

  //make sticky nav sticky
  if (this.mainNav || this.smallNav) {
    makeSticky = function(){
      var top  = window.pageYOffset || document.documentElement.scrollTop;
      top -= 200; //give it some bleed
      if (self.mainHeader) {
        if (top > self.smallNavOriginalTop && !self.mainHeader.hasClass("sticky")) {
          self.mainHeader.addClass('sticky');
        } else if (top <= self.smallNavOriginalTop && self.mainHeader.hasClass("sticky")) {
          self.mainHeader.removeClass('sticky');
        }
      }
      if (self.mainNav) {
        if (top > self.smallNavOriginalTop && !self.mainNav.hasClass("sticky")) {
          self.mainHeader.addClass('sticky');
          self.mainNav.addClass('sticky');
          self.mainNav.find("nav").addClass('sticky');
        } else if (top <= self.smallNavOriginalTop && self.mainNav.hasClass("sticky")) {
          self.mainHeader.removeClass('sticky');
          self.mainNav.removeClass('sticky');
          self.mainNav.find("nav").removeClass('sticky');
        }
      }

      if (self.smallNav) {
        if (top > self.smallNavOriginalTop && !self.smallNav.hasClass("sticky")) {
          self.smallNav.addClass('sticky');
        } else if (top <= self.smallNavOriginalTop && self.smallNav.hasClass("sticky")) {
          self.smallNav.removeClass('sticky');
        }
      }
    };

    $(window).scroll(makeSticky);
    makeSticky();
  }


  $body.on('click',".subsubnav-btn",function(e){
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).html("+");
      $(this).closest(".subnav").find(".subsubnav").removeClass('active');
    } else {
      $(this).addClass('active');
      $(this).html("-");
      $(this).closest(".subnav").find(".subsubnav").addClass('active');
    }
  });


} //end bindEvents
quell.saveCartNoteThenRedirect = function() {
  /*construct url */
  function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
  var token=get_cookie('cart');
  var myshopify_domain= window.MyShopifyDomain;
  var has_cart_note_or_attribute = false;
  
  try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
  var customer_param = ''
  checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param; 

  try {
      data={}
      jQuery("[name*='attributes']").each(function() {
          var input = jQuery(this)
          var input_type = jQuery(this).attr('type')
           
          if( input.val() != '' && ( (input_type != 'radio' && input_type != 'checkbox') || ( input_type == 'radio' && input.is(':checked') ) || ( input_type == 'checkbox' && input.prop('checked')) ) ){
              var name_attr = input.attr('name')
              data[name_attr]= input.val()
              has_cart_note_or_attribute= true   
           }
      });
      if( jQuery('[name="note"]').val() != undefined ){
          data['note'] = jQuery('[name="note"]').val();
          has_cart_note_or_attribute= true
      }
      if( jQuery('#terms, #agree').val() != undefined ){
          data['terms_and_conditions'] = jQuery('#terms, #agree').val();
          has_cart_note_or_attribute= true
      }
      if (has_cart_note_or_attribute) {
          jQuery.ajax({
              type: 'POST',
              data: data,
              url: '/cart/update.js',
              dataType: 'json',
              success: function() { 
                window.location.href=checkout_url
              }
          }); 
      } else {
           window.location.href=checkout_url
      }
  } catch (e) {
      window.location.href=checkout_url
  } //endtrycatch
  window.location.href=checkout_url
} //end saveCartNoteThenRedirect

quell.init();
$(document).ready(function() {
  var bgArray = ['http://quell20.wpengine.com/wp-content/uploads/2018/12/404-image-1.png', 'http://quell20.wpengine.com/wp-content/uploads/2018/12/404-image-2.png', 'http://quell20.wpengine.com/wp-content/uploads/2018/12/404-image-3.png' ];
  var bg = bgArray[Math.floor(Math.random() * bgArray.length)];
  var imageUrl = bg;
  $('.template-404 .image-wrap').css('background-image', 'url(' + imageUrl +')');
   if ($(window).width() < 767) {
   $('.error-page .banner-section').css('background-image', 'url(' + imageUrl +')');
}
});

/*Trustedsite JS*/
$(document).ready(function() {
 setTimeout(function(){
  $('#mfesecure-ts-image').css("height", "45px");
  $('#mfesecure-ts-image').css("width", "120px");
  $('#mfesecure-ts-image').css("background-size", "120px 50px");
 
  }, 500);
  
   setTimeout(function(){
   	console.log('testerd', $('[data-test-id="toast-frame"]'))
   $('[data-test-id="toast-frame"]').attr("aria-hidden","true");
  }, 2000);
   $('.section--shipping-method').addClass('test-class');
  
  $('.product-item').each(function () {
    var name = $(this).find('.product-name .product-title').text() ;
   	var rating = $(this).find('a.product-star-rating');
    if(rating.length) {
    	rating.attr('aria-label', name); 
    }
  });

  
});
/*End of Trustedsite JS*/